"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArtworkWithCheckIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

var _excluded = ["title"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** ArtworkWithCheck */
var ArtworkWithCheckIcon = function ArtworkWithCheckIcon(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Match and sell" : _ref$title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 125 161"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Title, null, title), /*#__PURE__*/_react.default.createElement(_Icon.Path, {
    fill: (0, _helpers.color)(props.fill),
    fillRule: "evenodd",
    d: "M58.666 2.908l-26.316 35H9.915a3.526 3.526 0 00-3.526 3.527v103.947a3.526 3.526 0 003.526 3.526h50.691a37.635 37.635 0 01-6.767-8.816H15.205V46.724h85.368v40.377a37.445 37.445 0 018.816 5.006V41.435a3.527 3.527 0 00-3.527-3.527h-20.88l-26.316-35zm0 13.312l-15.47 20.574h30.94L58.665 16.22z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Path, {
    fill: (0, _helpers.color)(props.fill),
    d: "M101.337 116.116a3.5 3.5 0 10-4.95-4.95L82.81 124.743l-5.671-5.671a3.5 3.5 0 10-4.95 4.95l10.62 10.621 18.528-18.527z"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Path, {
    fill: (0, _helpers.color)(props.fill),
    fillRule: "evenodd",
    d: "M86.88 91.435c-16.644 0-30.107 13.605-30.107 30.351s13.463 30.351 30.107 30.351 30.107-13.605 30.107-30.351a30.48 30.48 0 00-8.812-21.456 29.986 29.986 0 00-21.295-8.895zm-.003 7.15c12.678 0 22.984 10.371 22.984 23.201s-10.306 23.201-22.984 23.201c-12.677 0-22.983-10.371-22.983-23.201S74.2 98.585 86.877 98.585z",
    clipRule: "evenodd"
  }));
};

exports.ArtworkWithCheckIcon = ArtworkWithCheckIcon;
ArtworkWithCheckIcon.displayName = "ArtworkWithCheckIcon";
//# sourceMappingURL=ArtworkWithCheckIcon.js.map